import React from 'react';
import SelectCore from "./SelectCore";
import { FormControl } from '~/native-ui/FormControl';
import { Button, Icon, Text, Checkbox } from '~/native-ui';
import { Popover } from '~/native-ui/Popover';

export class Dropdown extends SelectCore {


    getListItemElement(inputProps) {
        return super.getListItemElement(inputProps, {
            handleClick: this.handleClick(),
        })
    };

    renderOptionIcons() {
        if (!this.props.multiSelect) return null;
        return <Icon ml="auto" iconFamily="material-community" type="checkbox-blank-outline" />
    }

    renderMultiSelectAdd() {
        if (!this.props.multiSelect) return null;
        if (this.isValueEmpty()) return null;
        return (
            <Button
                mt="2"
                maxWidth="100%"
                _stack={{ flex: 1, maxWidth: "100%", justifyContent: "center" }}
                icon={
                    <>
                        <Icon fontSize="sm" color="primary.500" type="add" iconFamily="material" />
                        <Text ml="2" fontSize="sm" isTruncated whiteSpace="nowrap">{ this.props.label }</Text>
                    </>
                }
                onPress={this.handleClick()}
                colorScheme="primary"
            />
        )
    }


    errorStyle = { color: 'danger.500' };
    render() {
        const [nbProps,dropdownProps] = this.extractProps();
        const {
            allowBlank,
            auto,
            labelKey,
            required,
            onChange,
            onFocus,
            onBlur, // eslint-disable-line no-unused-vars
            source,
            template,
            theme,
            minCharacters,
            multiSelect,
            minQueryLength,
            loading,
            filterHint,
            allowFiltering,
            onQueryChange,
            query,
            small,
            valueKey,
            templateValueClassName,
            selectedOptionClassName,
            optionClassName,
            label,
            tooltip,
            disabled,
            error,
            isReadOnly,
            isinvalid,
            ...others
        } = dropdownProps;

        return (
            <FormControl
                mt={!isReadOnly ? 'auto' : undefined}
                {...nbProps}
                isRequired={required}
                isDisabled={disabled}
                isInvalid={isinvalid}
            >
                {!error && label && <FormControl.Label key="label" label={label} tooltip={tooltip} />}
                {error && <FormControl.Label key="label" text={this.errorStyle} label={error} tooltip={tooltip} />}

                <Popover
                    key="popover"
                    trapFocus
                    shouldFlip
                    isKeyboardDismissable
                    shouldOverlapWithTrigger
                    placement="bottom left"
                    isOpen={!disabled && this.state.active}
                    onOpen={this.handleClick()}
                    onClose={this.close}
                    trigger={this.renderDropdownInterface}
                    initialFocusRef={this.filterInputElem}
                >
                    <Popover.Content minWidth={this.state.maxWidth}>
                        <Popover.Body p={0}>
                            {this.props.allowFiltering && this.renderFilterInput()}
                            {this.renderOptions()}
                        </Popover.Body>
                    </Popover.Content>
                </Popover>

                {this.renderMultiSelectAdd()}
            </FormControl>
        );
    }
}

export default Dropdown